import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useLocation, useParams } from 'react-router-dom';
import Header from './Header';
import ActionMenu from './ActionMenu';
import TrafficLightStatus from './TrafficLightStatus';
import { FilterProvider } from '../contexts/FilterContext';

const LayoutContainer = styled.div`
  background-color: black;
  height: 100vh;
  overflow: hidden;
`;


const MainContent = styled.main`
  height: calc(100vh - 73px); /* Fixed height to constrain content */
  margin-top: 73px;
  display: flex;
  background: black;
  overflow: hidden;
`;

/**
 * MAIN CONTENT AREA - Right side with white/light background
 * This is where the main page content lives (System Files, Document Analysis, etc.)
 * Located on the right side of the screen, light theme
 */
const ContentArea = styled.div`
  flex: 1;
  height: 100%;
  padding: ${props => props.noPadding ? '0' : '1.5rem 1.5rem 3rem 1.5rem'}; /* No padding for full-screen pages */
  background: black;
  overflow: ${props => props.noPadding ? 'hidden' : 'auto'}; /* Only hide scroll for full-screen pages (node view), otherwise allow scrolling */
  margin-left: ${props => props.isActionMenuExpanded ? '420px' : '100px'}; /* Dynamic margin based on ActionMenu state - always account for sidebar */
  min-width: 0; /* Allows flex item to shrink */
  transition: margin-left 0.3s ease; /* Smooth transition when ActionMenu expands */
  position: relative;
  z-index: 10; /* Higher than collapsed ActionMenuContainer to appear in front */
`;

const ContractStatusIndicator = styled.div`
  position: absolute;
  top: 2rem;
  right: 2rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: #f8fafc;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  z-index: 1001;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
`;

const StatusText = styled.div`
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
`;

const StatusSubtext = styled.div`
  font-size: 0.75rem;
  color: #6b7280;
  margin-top: 0.25rem;
`;



function Layout({ children, loanId: propLoanId, loanData }) {
  const location = useLocation();
  const [isActionMenuExpanded, setIsActionMenuExpanded] = useState(true); // Start expanded since Summary is active

  const handleActionMenuToggle = (expanded) => {
    setIsActionMenuExpanded(expanded);
  };

  // Extract loanId from URL pathname since useParams() doesn't work in parent of Routes
  const extractLoanIdFromPath = () => {
    const match = location.pathname.match(/\/(document-analysis|system-files|history)\/([^\/]+)/);
    return match ? match[2] : null;
  };
  
  const urlLoanId = extractLoanIdFromPath();
  
  // Use URL loanId if available, otherwise fall back to prop
  const actualLoanId = urlLoanId || propLoanId;

  // Check if we're in create mode or system files mode or history mode or have a loan selected
  const isCreateMode = location.pathname === '/create';
  const isSystemFilesMode = location.pathname === '/system-files';
  const isHistoryMode = location.pathname.includes('/history/');
  const hasLoanSelected = actualLoanId && actualLoanId !== null;
  const shouldShowStatus = !isCreateMode && !isSystemFilesMode && !isHistoryMode && hasLoanSelected;
  

  return (
    <FilterProvider>
      <LayoutContainer>
        <Header />
        
        <MainContent>
          <ActionMenu 
            loanId={actualLoanId} 
            loanData={loanData} 
            onToggle={handleActionMenuToggle}
          />
          <ContentArea isActionMenuExpanded={isActionMenuExpanded} noPadding={isHistoryMode}>
            
            {children}
          </ContentArea>
        </MainContent>
      </LayoutContainer>
    </FilterProvider>
  );
}

export default Layout;
